import { render, staticRenderFns } from "./ArbitratDetail.vue?vue&type=template&id=114eb55a&"
import script from "./ArbitratDetail.vue?vue&type=script&lang=js&"
export * from "./ArbitratDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArbitratDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports